import React, {useEffect } from "react";
import MobileProfileTopNavigation from "./MobileProfileTopNavigation";
import PrivacyPolicySection from "../../PageComponent/ProfilePage/PrivacyPolicySection";

function MobilePrivacyPolicy() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <div className="text-coalBlack pb-[25%] px-6 pt-10">
      <MobileProfileTopNavigation pageTitle={"Privacy and Safety"} />
      <PrivacyPolicySection />
    </div>
  );
}

export default MobilePrivacyPolicy;
